import { Component, OnInit } from "@angular/core";
import { ConfigService } from "src/app/services/config.service";

const template = `
<router-outlet></router-outlet>
`
@Component({
  selector: 'app-abc',
  template: template
})
export class AbcComponent {
}
